import React from 'react';
import { Users, Utensils, Building, Tv, Music, HeartHandshake } from 'lucide-react';
import PageHero, { Section, InfoCard, CTABlock } from '../components/PageHero';

const life = [
  { icon: Building, title: 'Hostel & Accommodation', desc: 'Fully furnished twin/triple-sharing rooms with 24×7 heating, Wi-Fi, laundry rooms and student common areas.' },
  { icon: Utensils, title: 'Food & Indian Mess', desc: 'Almost every university has an Indian mess serving daal, roti, sabzi, rice — plus local Russian cuisine for adventurous eaters.' },
  { icon: Users, title: 'Indian Community', desc: 'Every university has an active Indian Students Association that helps freshers with orientation, seniors, Bollywood nights & Diwali celebrations.' },
  { icon: Tv, title: 'Entertainment', desc: 'Netflix, YouTube, Hotstar all work fine. Movie theatres show Bollywood releases in bigger cities like Kazan, Moscow & Saint Petersburg.' },
  { icon: Music, title: 'Festivals & Culture', desc: 'Diwali, Holi, Independence Day, Christmas — all celebrated on campus. Russian holidays add extra long weekends to explore Europe.' },
  { icon: HeartHandshake, title: 'Safety', desc: 'Russian medical university campuses are among the safest — no ragging, gated hostels, and strong campus security.' },
];

export default function StudentLife() {
  return (
    <>
      <PageHero eyebrow="Life in Russia" title="Student Life" highlight="in Russia"
        subtitle="What actually happens between lectures and labs — food, festivals, friends, safety and everyday life for Indian medical students in Russia."
        breadcrumbs={[{ label: 'Student Life' }]} />

      <Section eyebrow="Everyday Life" title="From Hostel to" highlight="Home Kitchen">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {life.map((l, i) => <InfoCard key={i} icon={l.icon} title={l.title}>{l.desc}</InfoCard>)}
        </div>
      </Section>

      <Section eyebrow="A Day in the Life" title="Typical Day of an" highlight="Indian MBBS Student" muted>
        <div className="relative pl-4 md:pl-8 border-l-2 border-brand/25 space-y-4">
          {[
            { t: '7:30 AM', d: 'Breakfast in the hostel mess — usually paratha, chai, or bread with omelette.' },
            { t: '9:00 AM – 2:00 PM', d: 'Lectures + practical sessions in English — anatomy, physiology, biochemistry.' },
            { t: '2:00 PM', d: 'Lunch — daal, rice, sabzi at Indian mess. Group study with juniors/seniors.' },
            { t: '3:00 – 5:00 PM', d: 'Hospital rotations (from 3rd year onwards) or library self-study.' },
            { t: '6:00 PM', d: 'Sports — badminton, cricket practice at campus indoor courts (yes, indoor in winter!).' },
            { t: '8:00 PM', d: 'Dinner, group calls with family, Netflix, or exam prep with study buddies.' },
            { t: '11:00 PM', d: 'Wind down. Weekends: mall visits, city tours, movie nights, Bollywood dance meetings.' },
          ].map((s, i) => (
            <div key={i} className="relative">
              <div className="absolute -left-[26px] md:-left-[42px] w-6 h-6 rounded-full bg-brand text-white flex items-center justify-center text-[10px] font-bold">{i + 1}</div>
              <div className="bg-white rounded-2xl p-4 border border-border">
                <span className="font-serif text-lg font-bold text-brand">{s.t}</span>
                <p className="mt-1 text-sm text-muted-foreground">{s.d}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <CTABlock title="Have more questions about student life?" subtitle="Talk to a current MBBS student in Russia via our free video counselling programme." />
    </>
  );
}
